<template>
  <div class="avm-error h-screen flex justify-center items-center">
    <div class="flex flex-col items-center mb-20 px-5">
      <img src="/img/404.png" alt="Error 404" />
      <h4 class="mt-5">Ooops!</h4>
      <p class="mt-5 text-center">{{$t("error.404")}}</p>
      <v-btn
        rounded
        elevation="0"
        color="secondary"
        class="avm-btn avm-btn--large mt-5"
        @click="gohome"
      >
        {{$t('error.back_home')}}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    gohome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.avm-btn {
  background-color: #00adbc !important;
  text-transform: unset;
}

.avm-error {
  > .flex {
    max-width: 75vw;
  }
}
</style>
